import { render } from "./HistoryAmandemenImkpModal.vue?vue&type=template&id=0729a4aa&scoped=true"
import script from "./HistoryAmandemenImkpModal.vue?vue&type=script&lang=js"
export * from "./HistoryAmandemenImkpModal.vue?vue&type=script&lang=js"

import "./HistoryAmandemenImkpModal.vue?vue&type=style&index=0&id=0729a4aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0729a4aa"]])

export default __exports__